import { render, staticRenderFns } from "./OfferCode.vue?vue&type=template&id=40a81a96&scoped=true"
import script from "./OfferCode.vue?vue&type=script&lang=js"
export * from "./OfferCode.vue?vue&type=script&lang=js"
import style0 from "./OfferCode.vue?vue&type=style&index=0&id=40a81a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a81a96",
  null
  
)

export default component.exports